import React, { Component } from 'react';
import { BrowserRouter, Route,  Navigate } from 'react-router-dom'

import DatePicker from 'react-datepicker2';
import { Panel } from 'primereact/panel';

import Server from './../Server.js'
import { RadioButton } from 'primereact/radiobutton';
import { AutoComplete } from 'primereact/autocomplete';
import { Toast } from 'primereact/toast';

import { connect } from 'react-redux';
import { Loader } from 'rsuite';

class ShowPoll extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      layout: 'list',
      dashList: (this.props && this.props.location && this.props.location.state && this.props.location.state.list) ? this.props.location.state.list : [],
      dashData: (this.props && this.props.location && this.props.location.state && this.props.location.state.data) ? this.props.location.state.data : [],
      NewFactors: (this.props && this.props.location && this.props.location.state && this.props.location.state.NewFactors) ? this.props.location.state.NewFactors : null,
      NewUsers: (this.props && this.props.location && this.props.location.state && this.props.location.state.NewUsers) ? this.props.location.state.NewUsers : null,
      Shop: "",
      User: "",
      loading: 0

    }
    this.onHide = this.onHide.bind(this);
    this.selectedListChange = this.selectedListChange.bind(this);
    this.toast = React.createRef();


  }

  onSelect(event) {
    this.setState({ Shop: event.value.name, ShopId: event.value._id });

  }
  onSelect2(event) {
    this.setState({ User: event.value.name, UserId: event.value._id });
  }
  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {};
    if (this.state.user == 1) {
      param = {
        title: event.query,
        table: "users",
        name: ["name", "username"]
      };
    } else {
      param = {
        title: event.query,
        table: "shops",
        name: ["name", "name"]
      };
    }

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({ _id: v._id, name: v.name })
      })
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {

    }
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack)


  }
  itemTemplate(brand) {

    return (
      <div className="p-clearfix" style={{ direction: 'rtl', maxWidth: '100%' }} >
        <div style={{ margin: '10px 10px 0 0' }} className="row" _id={brand._id} >
          <div className="col-8" _id={brand._id} style={{ textAlign: 'right' }}>
            <span className="iranyekanwebregular" style={{ textAlign: 'right', overflow: 'hidden' }} _id={brand._id} >
              <span style={{ whiteSpace: 'pre-wrap' }} _id={brand._id}>{brand.name} </span><br />
            </span>
          </div>

        </div>
      </div>
    );
  }


  selectedCatTemplate(option, props) {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div>{option.name}</div>
        </div>
      );
    }

    return (
      <span>
        {props.placeholder}
      </span>
    );
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        SellerId: response.data.authData.UserId,
        loading: 0
      })
      that.getSettings();

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }

  onHide(event) {

    this.setState({
      selectedId: null,
      Shop: null,
      User: "",
    });
    this.GetPoll();
  }
  selectedListChange(value) {

    this.setState({
      visibleDialog: true,
      selectedId: value._id,
      Shop: value.Shop,
      User: value.User
    })

  }
  getSettings() {
    let that = this;
    that.Server.send("AdminApi/getSettings", {}, function (response) {
      if (response.data.result) {
        that.setState({
          ProductBase: response.data.result[0] ? response.data.result[0].ProductBase : false,
          SaleFromMultiShops: response.data.result[0] ? response.data.result[0].SaleFromMultiShops : false,
          Raymand: response.data.result[0] ? response.data.result[0].Raymand : false,
          System: response.data.result[0] ? response.data.result[0].System : "shop",
          CreditSupport: response.data.result[0] ? response.data.result[0].CreditSupport : "shop",
          SystemTitle: (response.data.result[0]?.System == "shop" || response.data.result[0].CreditSupport) ? "فروشگاه" : "زیر سیستم"

        })
      }
      that.GetPoll();

    }, function (error) {
    })


  }
  GetPoll() {
    let that = this;
    let param = {
    };
    that.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      let types=[];
      for(let i=0;i<response.data.result.length;i++)
        types.push({name:response.data.result[i].name,value:response.data.result[i].latinName})

        
      that.setState({
        types:types,
        loading: 0
      })


    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/getPolls", param, SCallBack, ECallBack)
  }

  setPollRecord(){
    let that = this;
   
    if(!this.state.Shop){
      that.toast.current.show({ severity: 'warn', summary: <div> فروشگاه را وارد کنید </div>, life: 8000 });

      return;
    }
    if(!this.state.User){
      that.toast.current.show({ severity: 'warn', summary: <div> نام کاربر را وارد کنید </div>, life: 8000 });

      return;
    }
    if(!this.state.Date){
      that.toast.current.show({ severity: 'warn', summary: <div>  تاریخ را وارد کنید </div>, life: 8000 });

      return;
    }
    let answered = [];
    
    for(let id of that.state.ids){
      let a = {};
      a[id] = this.state[id]
      answered.push(a)
    }
    that.setState({
      loading: 1
    })
    let param={
      answered:answered,
      Shop:this.state.ShopId,
      User:this.state.UserId,
      Date:this.state.Date.local("fa").format("jYYYY/jM/jD")
    }
    let SCallBack = function (response) {
      if(response.data.error){
        that.toast.current.show({ severity: 'warn', summary: <div> {response.data.error} </div>, life: 8000 });

      }else{
        that.toast.current.show({ severity: 'success', summary: <div>  عملیات با موفقیت انجام شد </div>, life: 8000 });

      }
      that.setState({
        loading: 0
      })

    };
    let ECallBack = function (error) {
      that.toast.current.show({ severity: 'error', summary: <div>  عملیات انجام نشد </div>, life: 8000 });

      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/setPollRecord", param, SCallBack, ECallBack)

  }

  showPolls() {
    let that = this;
    let param = {
      type: this.state.type,
      Shop : this.state.ShopId ? this.state.ShopId : null,
      User : this.state.UserId ? this.state.UserId : null,
    };
    that.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      
      that.setState({
        answered: response.data.result,
        loading: 0
      })

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/getPollAnswere", param, SCallBack, ECallBack)
  }


  selectedTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div>{option.name}</div>
        </div>
      );
    }

    return (
      <span>
        {props.placeholder}
      </span>
    );
  }
  render() {

    return (
      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
          <Toast ref={this.toast} position="bottom-left" style={{ fontFamily: 'YekanBakhFaBold', textAlign: 'right' }} />

        <div className="row justify-content-center mt-2">
          <div className=" col-12" style={{ background: '#fff' }}>
            <Panel header="جستجوی نظرسنجی" style={{ textAlign: 'right', marginBottom: 50, fontFamily: 'yekan' }}>
              <div className="row">
              <div className="col-lg-4">
                <select className="form-control irsans" value={this.state.type} name="type" onChange={(event) => {
                  this.setState({
                    type: event.target.value
                  })
                }
                } >
                   return (<option value="" >نوع نظرسنجی را وارد کنید</option>)

                  {
                    this.state.types && this.state.types.map((v, i) => {
                      return (<option value={v.value} >{v.name}</option>)
                    })
                  }
                </select>
              </div>
                <div className="col-lg-4">
                  <div>
                    <AutoComplete placeholder={`نام ${this.state.SystemTitle}`} style={{ width: '100%' }} onChange={(event) => { this.setState({ Shop: event.value, user: 0, ShopId: null }) }} itemTemplate={this.itemTemplate.bind(this)} value={this.state.Shop} onSelect={(e) => this.onSelect(e)} suggestions={this.state.brandSuggestions} completeMethod={this.suggestBrands.bind(this)} />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div >
                    <AutoComplete placeholder="کاربر" style={{ width: '100%' }} onChange={(event) => { this.setState({ User: event.value, user: 1, UserId: null }) }} itemTemplate={this.itemTemplate.bind(this)} value={this.state.User} onSelect={(e) => this.onSelect2(e)} suggestions={this.state.brandSuggestions} completeMethod={this.suggestBrands.bind(this)} />
                  </div>
                </div>
              
                <div className="col-12" style={{ background: '#fff',marginTop:50 }}>
                  {this.state.questions && this.state.questions.map((item, index) => {

                    if (item.options && item.options.length > 0) {
                      return (
                        <div className="col-12 col-lg-3" style={{marginBottom:50}}>
                          <p style={{fontSize:18}}>{index+1} - {item.text}</p>

                          <div >
                            {item.options && item.options.map((op) => {
                              return (
                                <div>
                                  <RadioButton name={item._id} inputId={item._id+"_"+op.id} value={op.id} checked={this.state[item._id] == op.id} onChange={(e) => { this.setState({ [item._id]: e.value }); }} />
                                  <span htmlFor="TypeOfPayment1" className="p-checkbox-label yekan" style={{  color: 'rgb(185 185 185)',marginRight:10,fontSize:15 }}>
                                    {op.title}
                                  </span>
                                </div>
                              )


                            })}
                          </div>
                        </div>
                      )


                    } else {
                      return (

                        <div className="col-12 col-lg-3" style={{marginBottom:50}}>
                          <div  >
                          <label className="YekanBakhFaBold">{index+1} - {item.text}</label>

                            <input className="form-control YekanBakhFaBold" style={{ textAlign: 'center' }} type="text" id={this.state[item._id]} name={item._id} value={this.state[item._id]} onChange={(event) => { this.setState({ [item._id]: event.target.value }) }} required />
                          </div>
                        </div>
                      )
                    }
                  })}

                </div>
                <div className="col-lg-12">
                  <button className="btn btn-primary irsans" onClick={()=>{
                    this.showPolls();
                  }} style={{ width: "200px", marginTop: "5px", marginBottom: "5px" }}> مشاهده </button>
                </div>
              </div>
            </Panel>
          </div>
        </div>

      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(ShowPoll)